import { CheckCircle2, Clock, AlertTriangle, BarChart3, Send, Loader } from "lucide-react";
import { useTranslation } from "react-i18next";

export function StatusBadge({ status, isVoting, scrutinyRequestStatus }) {
  const { t } = useTranslation();

  if (isVoting) {
    return (
      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-700">
        <CheckCircle2 className="h-3.5 w-3.5" />{t('status.voting')}
      </span>
    );
  }

  // Show "Pendent Blockchain" when waiting for blockchain writes
  if (status === "pending_blockchain") {
    return (
      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium bg-orange-100 text-orange-700" data-testid="status-pending-blockchain">
        <Loader className="h-3.5 w-3.5 animate-spin" />{t('status.pendingBlockchain')}
      </span>
    );
  }

  // Show "Pendent de Clau" when admin has approved and entity needs to enter key
  if (status === "closed" && scrutinyRequestStatus === "admin_approved") {
    return (
      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium bg-emerald-100 text-emerald-700" data-testid="status-pending-key">
        <Send className="h-3.5 w-3.5" />{t('status.pendingKey')}
      </span>
    );
  }

  // Show "Escrutini Sol·licitat" when closed with pending scrutiny request
  if (status === "closed" && scrutinyRequestStatus) {
    return (
      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium bg-indigo-100 text-indigo-700" data-testid="status-scrutiny-requested">
        <Send className="h-3.5 w-3.5" />{t('status.scrutinyRequested')}
      </span>
    );
  }

  const configs = {
    draft: { bg: 'bg-slate-100', text: 'text-slate-700', icon: Clock, label: t('status.draft') },
    pending_publication: { bg: 'bg-orange-100', text: 'text-orange-700', icon: Clock, label: t('status.pendingPublication') },
    published: { bg: 'bg-blue-100', text: 'text-blue-700', icon: CheckCircle2, label: t('status.published') },
    closed: { bg: 'bg-amber-100', text: 'text-amber-700', icon: AlertTriangle, label: t('status.closed') },
    pending_closure: { bg: 'bg-red-100', text: 'text-red-700', icon: Clock, label: t('status.pendingClosure') },
    expired: { bg: 'bg-slate-100', text: 'text-slate-500', icon: Clock, label: t('status.expired') },
    scrutinized: { bg: 'bg-purple-100', text: 'text-purple-700', icon: BarChart3, label: t('status.scrutinized') },
  };

  const cfg = configs[status];
  if (!cfg) return null;
  const Icon = cfg.icon;

  return (
    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium ${cfg.bg} ${cfg.text}`}>
      <Icon className="h-3.5 w-3.5" />{cfg.label}
    </span>
  );
}
